/**
 * Whether the mobile bottom navigation has slid away, for page chrome that rests
 * above it (the blog editor's pinned bottom bar), so that chrome can follow the
 * navigation down instead of hovering over an empty band.
 *
 * `MobileNav` publishes its hide-on-scroll state as this attribute on the
 * document element, the way MainLayout publishes `--ows-imp-offset`: as
 * something page CSS can read, so a page follows the navigation without
 * re-rendering on every scroll toggle. The attribute is present only while the
 * pill is scrolled away with its "More" drawer closed. It is absent on desktop,
 * under reduced motion (the pill never hides there), and whenever the layout is
 * not mounted, so a page outside MainLayout (or in a CT mount) reads the
 * navigation as shown.
 */
export const MOBILE_NAV_HIDDEN_ATTR = 'data-ows-mobile-nav-hidden';

/**
 * Selector prefix for styled-components rules that apply while the navigation is
 * hidden: `${MOBILE_NAV_HIDDEN} & { … }`.
 */
export const MOBILE_NAV_HIDDEN = `html[${MOBILE_NAV_HIDDEN_ATTR}]`;

/**
 * Whether the mobile bottom navigation's "More" drawer is open (or closing): its overlay then covers the page, under
 * the pill. Page chrome raised over the navigation's scrim (Game Lists' Create a new list) goes back under it.
 */
export const MOBILE_NAV_DRAWER_ATTR = 'data-ows-mobile-drawer-open';

/** Selector prefix for styled-components rules that apply while the drawer is open: `${MOBILE_NAV_DRAWER_OPEN} & {…}`. */
export const MOBILE_NAV_DRAWER_OPEN = `html[${MOBILE_NAV_DRAWER_ATTR}]`;
